import { pushPwaInstalledLaunchEvent } from 'src/utils/gtm';

const SERVICE_WORKER_URL = '/browser-notification-sw.js';

export async function getRewardBloomServiceWorkerRegistration(): Promise<ServiceWorkerRegistration> {
  return navigator.serviceWorker.register(SERVICE_WORKER_URL, {
    scope: '/',
    updateViaCache: 'none',
  });
}

export function registerRewardBloomServiceWorker(): void {
  pushPwaInstalledLaunchEvent();

  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener(
    'load',
    () => {
      void getRewardBloomServiceWorkerRegistration()
        .then((registration) => registration.update())
        .catch((error: unknown) => {
          console.error('Failed to register the RewardBloom service worker:', error);
        });
    },
    { once: true }
  );
}
